import {
  NBS_API_GET_PROFILE_CONTROLS_REQUEST,
  NBS_API_GET_PROFILE_CONTROLS_SUCCESS,
  NBS_API_GET_PROFILE_CONTROLS_FAILURE
} from '../../constants/actions';

import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiGetProfileControlsRequest () {
  return { type: NBS_API_GET_PROFILE_CONTROLS_REQUEST };
}
function nbsApiGetProfileControlsSuccess (response) {
  return {
    type: NBS_API_GET_PROFILE_CONTROLS_SUCCESS,
    response
  };
}
function nbsApiGetProfileControlsError (error) {
  return {
    type: NBS_API_GET_PROFILE_CONTROLS_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiGetProfileControls (data) {
  const url = 'getProfileExtControls';
  if (!data.language) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiGetProfileControlsRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiGetProfileControlsSuccess(response)))
      .catch(error => dispatch(nbsApiGetProfileControlsError(error)));
  };
}
